/* @flow */

import React from 'react';
import ResourceImage from 'shared/components/ResourceImage';
import RawImage from 'shared/components/RawImage';

type Props = {
  strategy?: ResourceStrategy,
  resource?: CatalogResource,
};

const getImageByStrategy = (type, resource) => {
  switch (type) {
    case 'template':
      return resource && resource.source;
    case 'server':
    case 'client':
      return resource && (resource.resource || resource.source);
    default:
      return null;
  }
};

const OctoResourceImage = ({ strategy, resource }: Props) => {
  const type = resource
    ? resource.strategy.type
    : strategy ? strategy.type : 'template';

  if (resource && resource.raw) {
    return <RawImage raw={resource.raw} />;
  }

  return <ResourceImage resource={getImageByStrategy(type, resource)} />;
};

export default OctoResourceImage;



// WEBPACK FOOTER //
// ./src/shared/components/OctoResourceImage.js